import styled from "styled-components";

export const ResultSection = styled.div`
  display: flex;
  weight: 100%;
  background: ${(props) => props.theme.colors.white};
  flex-direction: column;
`;
